<template>

  <Shell :title="$t('titles.locations')">

    <router-view></router-view>

  </Shell>  

</template>

<script setup lang="ts">

import Shell from '../Shell.vue'

</script>
